export default __webpack_public_path__ + "static/media/GoodHabitz_black.46299c0a.svg";